import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { Block, ContainedButton, DefaultText, PaperBlock } from '@guryou/html-components';

import ExportCSV from './ExportCSV';
import FileReportTable from './FileReportTable';

const FileReport = ({ data }) => {
  const ref = useRef();
  const { t } = useTranslation();

  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });

  if (!data.data?.length) {
    return (
      <PaperBlock xs={12}>
        <DefaultText>{t('SECTION_VIDEOS.noDataToGenerate')}</DefaultText>
      </PaperBlock>
    );
  }
  return (
    <>
      <PaperBlock xs={12} height="70vh" overflow="scroll" margin={0} padding={0}>
        <FileReportTable printData={data.data} ref={ref} />
      </PaperBlock>
      <Block margin={0} display="flex" justifyContent="end">
        <ContainedButton onClick={handlePrint}>{t('SECTION_VIDEOS.print')}</ContainedButton>
        <ExportCSV data={data.data} filename="video_report.csv"></ExportCSV>
      </Block>
    </>
  );
};

export default FileReport;
